import { Box, ClickAwayListener, Divider, styled } from "@mui/material";
import { DropDownProps } from "./types";
import React from "react";

const DropDownMenu: React.FC<DropDownProps> = ({
  dropDownOptions = [],
  onMouseLeave,
  customOptions,
  className,
  title,
  onClickAway,
  dividerIndex,
}) => {
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <StyledBox onMouseLeave={onMouseLeave} className={className}>
        {title && <span className="dropdown-title">{title}</span>}
        <ul>
          {customOptions &&
            customOptions.map((item, index) => (
              <React.Fragment key={index}>
                <li className="custom-option">{item}</li>
                {dividerIndex === index && <Divider key={`divider-${index}`} />}
              </React.Fragment>
            ))}
          {dropDownOptions.map((item) => (
            <>
              <Box key={item.label} component="li" p={2} onClick={item.onClick}>
                {item.label}
              </Box>
              {item.hasDividerAfter && <Divider />}
            </>
          ))}
        </ul>
      </StyledBox>
    </ClickAwayListener>
  );
};
export default DropDownMenu;
const StyledBox = styled(Box)(({ theme }) => ({
  zIndex: "10",
  top: "calc(100% + 8px)",
  right: "0",
  position: "absolute",
  minWidth: "210px",
  fontSize: "14px",
  fontWeight: 400,
  backgroundColor: theme.tokens.colors.gray[1],
  color: theme.tokens.colors.gray[7],
  textAlign: "left",
  boxShadow: "0px 4px 8px 0px #00000026",

  transition: "0.5s",
  ul: {
    padding: 0,
    margin: "0.5rem 0",
  },
  li: {
    cursor: "pointer",
    listStyle: "none",
    padding: "0.5rem 1rem",
    fontFamily: theme.typography.fontFamily,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  "li.custom-option": {
    padding: "0",
  },
}));
